export default "__VITE_ASSET__CbAnuWzF__"